<script setup lang="ts">
import { useSnackbar } from '@/utils/Notifyer'

const { snackbar } = useSnackbar()
</script>

<template>
  <v-snackbar v-model="snackbar.show" :color="snackbar.color" rounded="pill" :timeout="4000">
    {{ snackbar.message }}
  </v-snackbar>
</template>
